// extracted by mini-css-extract-plugin
module.exports = {"b":"_1x8d6","toggle":"_27Iq4","check":"_3FfKC","track":"_2cFGi","blueToggle":"_2v_bU","switch":"_1fe4G"};